// M4-B player actions (markets & money), re-exported through src/core/actions.js. Each returns { ok, msg, ... }.
import { leaseCushingImpl } from './marketNegative.js';
import { setGasOutletImpl, setGasModeImpl, signLngSpaImpl } from './marketGas.js';
import { openRblImpl, drawRblImpl, repayRblImpl, hedgeM4Impl, closeHedgeM4Impl } from './marketFinance.js';
import { acceptLandContractImpl } from './marketRigs.js';
import { mk, peek } from './marketCore.js';

// §8.4 Cushing tank lease: { mmbbl = 1, months = 1, fill = true } (fill = buy crude now and sell it forward).
export const leaseCushingStorage = (state, opts = {}) => leaseCushingImpl(state, opts ?? {});
// §9 gas: outlet (gas transport def id or null), mode 'auto' | 'sell' | 'flare', 20-year oil-indexed LNG SPA.
export const setGasOutlet = (state, fieldId, defId) => setGasOutletImpl(state, fieldId, defId);
export const setGasMode = (state, fieldId, mode) => setGasModeImpl(state, fieldId, mode);
export const signLngSpa = (state, fieldId) => signLngSpaImpl(state, fieldId);
// §8.2 firm pipelines: set the take-or-pay volume (bbl/d) on the field's current firm commitment (raise any time;
// lower only within 30 days of signing).
export function setFirmCommitment(state, fieldId, bbld) {
  const C = peek(state)?.firm?.[fieldId];
  if (!C) return { ok: false, msg: 'This field has no firm pipeline commitment.' };
  const v = Math.max(0, Math.round(Number(bbld) || 0));
  if (v < C.bbld && state.day - C.startDay > 30) return { ok: false, msg: 'Take-or-pay volumes can only be raised once the contract has run 30 days.' };
  mk(state).firm[fieldId].bbld = v;
  return { ok: true, msg: `Firm commitment set to ${v.toLocaleString('en-US')} bbl/d.` };
}
// §7 shale finance: reserve-based facility and M4 hedges ({ kind: 'swap'|'collar'|'put'|'three_way', months, bblPerMonth, floor?, subFloor? }).
export const openRbl = (state, opts = {}) => openRblImpl(state, opts ?? {});
export const drawRbl = (state, amount) => drawRblImpl(state, amount);
export const repayRbl = (state, amount) => repayRblImpl(state, amount);
export const hedgeM4 = (state, opts = {}) => { const { strike, skipCap, ...o } = opts ?? {}; return hedgeM4Impl(state, o); }; // setup-only options stripped
export const closeHedgeM4 = (state, id) => closeHedgeM4Impl(state, id);
// §6 land rig contract board (offers in m4RigMarketView().landBoard).
export const acceptLandContract = (state, offerId, rigUid) => acceptLandContractImpl(state, offerId, rigUid);
